import { HowItWorksButton } from '@/features/welcome/components/HowItWorksButton';
import { AccountMenu } from './AccountMenu';
import { CartButton } from './CartButton';
import { ExperienceToggle } from './ExperienceToggle';
import { OrdersButton } from './OrdersButton';
import { useOnStorefront } from '../hooks/use-on-storefront';

/**
 * O `rightSlot` da `Topbar` — montado **dentro do ramo protegido**, e isso é
 * o ponto.
 *
 * O mesmo `RootLayout` serve `/login` e o catch-all público. Montar
 * `useExperience()` lá o faria rodar com `user: null` a cada visita deslogada,
 * e o carrinho dispararia um request autenticado numa tela sem sessão.
 *
 * **Só a partir de `sm`.** No celular estas mesmas ações vivem no
 * `StorefrontMobileActions`, onde viram linhas de 44px num painel — quatro
 * ícones de 36px disputando a barra com a logo e a busca não deixavam largura
 * suficiente para nenhum dos dois. Quem decide qual dos dois aparece é a
 * `Topbar`, por CSS.
 */
export function StorefrontHeaderActions() {
  const naVitrine = useOnStorefront();

  return (
    <>
      {/* Primeiro da fila: é convite, não controle — fica antes dos ícones. */}
      {naVitrine && <HowItWorksButton />}
      <ExperienceToggle />
      {naVitrine && <OrdersButton />}
      {naVitrine && <CartButton />}
      <AccountMenu />
    </>
  );
}
